export default __webpack_public_path__ + "static/media/color_2.b7d4ca07.png";